import { EmailComponent } from '@aca-new/app/shared/components/email/email.component';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { QimaAvatarModule, QimaChipModule, QimaInputMultipleEmailModule } from '@qima/ngx-qima';

@NgModule({
  declarations: [EmailComponent],
  exports: [EmailComponent],
  imports: [QimaAvatarModule, QimaChipModule, QimaInputMultipleEmailModule, ReactiveFormsModule],
})
export class EmailModule {}
